export default __webpack_public_path__ + "static/media/bg-3.71474e9c.jpg";